import { BlockTimeVarianceInterface } from '../interfaces/block-time-variance.interface';
import { BLOCK_TIME_VARIANCE_THRESHOLD } from '../properties/block-time-record-modal.properties';

/**
 * Calculates the difference between the actual block time and the estimate.
 * The result is null if there is no estimate or if the difference is below the threshold.
 */
export function calculateBlockTimeVariance(
  estimatedHours: string | number | null | undefined,
  actualHours: string | number | null | undefined,
): BlockTimeVarianceInterface | null {
  const estimated = Number(estimatedHours);
  const actual = Number(actualHours);

  if (estimatedHours === null || estimatedHours === undefined || estimatedHours === '' || !Number.isFinite(estimated)) {
    return null;
  }

  const difference = Number(((Number.isFinite(actual) ? actual : 0) - estimated).toFixed(2));

  if (Math.abs(difference) < BLOCK_TIME_VARIANCE_THRESHOLD) {
    return null;
  }

  const hours = Math.abs(difference).toFixed(2);
  const direction = difference > 0 ? 'over' : 'under';

  return {
    hours,
    direction,
    label: `${hours} hrs ${direction} estimate`,
    theme: direction === 'over' ? 'warning' : 'gray',
  };
}
